import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../components/button'
import CustomModal from '../../../components/CustomModal'
import FileUpload from '../../../components/FileUpload'
import Input from '../../../components/input'
import Select from '../../../components/Select'
import { fetchPermissionDropdown } from '../../../store/Slices/PermissionSlice'
import { clearSingleUser, editUser, fetchUserRoleDropdown, fetchUsersData, getSingleUser } from '../../../store/Slices/UserSlice'
import { editUserValidationSchema } from '../../../utils/Schema'
import { errorNotify, successNotify } from '../../../utils/toast'

const EditUser = ({ show, onHide, userId, currentPage, limit, searchFilters }) => {
    const dispatch = useDispatch();
    const { userRoles, userRoleLoading, editLoading, singleUser, singleUserLoading } = useSelector((state) => state.users);
    const { permissionDropdown, permissionLoading } = useSelector((state) => state.permissions);

    const [uploadedFiles, setUploadedFiles] = useState([]);

    useEffect(() => {
        if (show && userId) {
            dispatch(fetchUserRoleDropdown());
            dispatch(fetchPermissionDropdown());
            dispatch(getSingleUser(userId));
        }

        return () => {
            if (!show) {
                dispatch(clearSingleUser());
            }
        };
    }, [show, userId, dispatch]);

    useEffect(() => {
        if (singleUser && singleUser?.image) {
            setUploadedFiles([{
                fileName: singleUser?.image,
                originalName: singleUser?.image,
                previewUrl: null,
                backend: true
            }]);
        }
    }, [singleUser])

    const initialValues = {
        name: singleUser?.username || '',
        email: singleUser?.email || '',
        role_id: singleUser?.my_role?.id || '',
        group_permissions_id: singleUser?.my_role?.slug === "super-admin" ? '0' : singleUser?.group_permissions?.[0]?.id || ''
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const userData = {
                user_id: userId,
                name: values.name,
                role_id: 0,
                group_permissions_id: singleUser?.my_role?.slug === "super-admin" ? '0' : values.group_permissions_id,
                image: uploadedFiles[0]?.fileName || ''
            };

            await dispatch(editUser(userData)).unwrap();
            successNotify('User updated successfully');
            resetForm();
            onHide();
            setUploadedFiles([]);
            dispatch(fetchUsersData({
                page: currentPage,
                limit: limit,
                ...(searchFilters && { searchFilters: searchFilters })
            }));
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <CustomModal heading="Edit User" size="lg" show={show} handleClose={onHide}>
                {
                    singleUserLoading ? <div className='loading_spinner'><Spinner animation="grow" /></div> :
                        <Formik
                            initialValues={initialValues}
                            validationSchema={editUserValidationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize={true}
                        >
                            {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                                <Form>
                                    <div className='add_user_modal'>
                                        <h5>User Information</h5>

                                        <div>
                                            <Input
                                                label="Name"
                                                placeholder="Enter Full Name"
                                                type="text"
                                                name="name"
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.name}
                                                touched={touched.name}
                                            />
                                            <Input
                                                label="Email Address"
                                                placeholder="Enter Email Address"
                                                type="email"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                touched={touched.email}
                                                disabled={true}
                                                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                            />

                                            {/* <Input
                                                label="Default Password"
                                                placeholder=""
                                                type="password"
                                                name="password"
                                                value={"Name123!"}
                                                disabled={true}
                                            /> */}

                                            <hr />
                                        </div>

                                        <h5>User Role and Permissions</h5>

                                        <div>
                                            {/* <Select
                                                label="User Role"
                                                placeholder="Select User Role"
                                                options={userRoles}
                                                loading={userRoleLoading}
                                                name="role_id"
                                                value={userRoles.find(role => role.value === values.role_id)}
                                                onChange={(selectedOption) => setFieldValue('role_id', selectedOption?.value || '')}
                                                onBlur={handleBlur}
                                                error={errors.role_id}
                                                touched={touched.role_id}
                                            /> */}

                                            {
                                                singleUser?.my_role?.slug === "super-admin" ?
                                                    <Select
                                                        label="Permission Group"
                                                        placeholder="Select Permission Group"
                                                        options={[{ value: "super-admin", label: "Super Admin" }]}
                                                        loading={permissionLoading}
                                                        name="group_permissions_id"
                                                        value={{ value: "super-admin", label: "Super Admin" }}
                                                        onChange={(selectedOption) => setFieldValue('group_permissions_id', selectedOption?.value || '')}
                                                        onBlur={handleBlur}
                                                        error={errors.group_permissions_id}
                                                        touched={touched.group_permissions_id}
                                                        isDisabled={true}
                                                    /> :
                                                    <Select
                                                        label="Permission Group"
                                                        placeholder="Select Permission Group"
                                                        options={permissionDropdown}
                                                        loading={permissionLoading}
                                                        name="group_permissions_id"
                                                        value={permissionDropdown.find(permission => permission.value === values.group_permissions_id)}
                                                        onChange={(selectedOption) => setFieldValue('group_permissions_id', selectedOption?.value || '')}
                                                        onBlur={handleBlur}
                                                        error={errors.group_permissions_id}
                                                        touched={touched.group_permissions_id}
                                                    />
                                            }
                                        </div>

                                        <div className='photo_document_section'>
                                            <FileUpload
                                                destination="add-user"
                                                files={uploadedFiles}
                                                setFiles={setUploadedFiles}
                                                maxFileSize={10}
                                                disabled={uploadedFiles.length >= 1}
                                            />
                                        </div>

                                        <div style={{ marginTop: "80px" }}>
                                            <Button
                                                cancelBtn={onHide}
                                                submitBtn={() => { }}
                                                loading={editLoading || isSubmitting}
                                                disabled={editLoading || isSubmitting}
                                                submitText="Update"
                                                type="submit"
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                }
            </CustomModal>
        </div>
    )
}

export default EditUser